export const iconFontAwesomeHumanitarianOilWell = (
	<i className="fa-solid fa-oil-well"></i>
);
